var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-card",
        { staticClass: "soli-round" },
        [
          _c(
            "v-container",
            [
              _c("v-card-title", { staticClass: "soli-grey pb-0" }, [
                _vm._v("\n                Contact History\n            "),
              ]),
              _vm._v(" "),
              _c(
                "v-tabs",
                {
                  staticClass: "px-4",
                  attrs: { dense: "" },
                  model: {
                    value: _vm.tab,
                    callback: function ($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab",
                  },
                },
                [
                  _c("v-tab", [_vm._v("Received")]),
                  _vm._v(" "),
                  _c("v-tab", [_vm._v("Sent")]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-tabs-items",
                {
                  model: {
                    value: _vm.tab,
                    callback: function ($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab",
                  },
                },
                [
                  _c(
                    "v-tab-item",
                    [
                      _c(
                        "v-container",
                        [
                          !_vm.receivedHistory
                            ? _c("v-skeleton-loader", {
                                staticClass: "mb-6",
                                attrs: {
                                  type: "list-item-avatar-three-line, list-item-avatar-three-line, list-item-avatar-three-line",
                                  boilerplate: "",
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("v-simple-table", [
                            _c(
                              "tbody",
                              _vm._l(_vm.receivedHistory, function (item) {
                                return _c("tr", { key: item.id }, [
                                  _c("td", [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(
                                          _vm.globalMomentDateAtTimeDots(
                                            item.created_at
                                          )
                                        ) +
                                        "\n                                    "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      class: item.properties.message_url
                                        ? "soli-link"
                                        : null,
                                      on: {
                                        click: function ($event) {
                                          return _vm.fetchHtmlContent(
                                            item.properties.message_url
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(item.properties.subject) +
                                          "\n                                    "
                                      ),
                                    ]
                                  ),
                                ])
                              }),
                              0
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-tab-item",
                    [
                      _c(
                        "v-container",
                        [
                          !_vm.sentHistory
                            ? _c("v-skeleton-loader", {
                                staticClass: "mb-6",
                                attrs: {
                                  type: "list-item-avatar-three-line, list-item-avatar-three-line, list-item-avatar-three-line",
                                  boilerplate: "",
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("v-simple-table", [
                            _c(
                              "tbody",
                              _vm._l(_vm.sentHistory, function (item) {
                                return _c("tr", { key: item.id }, [
                                  _c("td", [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(
                                          _vm.globalMomentDateAtTimeDots(
                                            item.created_at
                                          )
                                        ) +
                                        "\n                                    "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      class: item.properties.message_url
                                        ? "soli-link"
                                        : null,
                                      on: {
                                        click: function ($event) {
                                          return _vm.fetchHtmlContent(
                                            item.properties.message_url,
                                            item.properties.copied_recipients
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(item.properties.subject) +
                                          "\n                                    "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "sent-recipients" }, [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(
                                          item.properties.copied_recipients
                                        ) +
                                        "\n                                    "
                                    ),
                                  ]),
                                ])
                              }),
                              0
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.openMail
        ? _c("SoliForm", {
            ref: "mail",
            attrs: {
              textSubtitle: _vm.openMail.recipients
                ? `Recipients: ${_vm.openMail.recipients}`
                : null,
              saveChanges: false,
              title: "Preview Message",
              large: "",
              noContainer: !_vm.loading,
              subtitle: _vm.loading ? null : [],
              hideBtn: "",
            },
            on: { reset: _vm.closeMail },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [
                      !_vm.loading
                        ? _c("div", {
                            directives: [
                              {
                                name: "dompurify-html",
                                rawName: "v-dompurify-html",
                                value: _vm.htmlContent,
                                expression: "htmlContent",
                              },
                            ],
                            staticClass:
                              "h-full w-full overflow-auto relative custom-html-content",
                          })
                        : _c("v-skeleton-loader", { attrs: { type: "image" } }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              4114651013
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }